<p-dropdown *ngIf="!multi"
  [options]="options"
  [placeholder]="placeholder"
  [optionLabel]="optionLabel"
  [optionValue]="optionValue"
  [disabled]="disabled"
  [appendTo]="appendTo"
  [style.--multi-border-color]="borderColor"
  [(ngModel)]="value"
  [class.outlined]="type === 'outlined'"
  (onChange)="onDropdownChange($event.value)">
  <ng-template *ngIf="selectedPrefix" pTemplate="selectedItem" let-option>
    {{ selectedPrefix }}{{ getOptionLabel(option) }}
  </ng-template>
</p-dropdown>

<p-multiSelect *ngIf="multi"
  #multiSelect
  [options]="searchInput ? displayOptions : options"
  [placeholder]="placeholder"
  [optionLabel]="optionLabel"
  [optionValue]="optionValue"
  [disabled]="disabled"
  [appendTo]="appendTo"
  [(ngModel)]="value"
  [class.outlined]="type === 'outlined'"
  [style.--multi-border-color]="borderColor"
  [display]="display"
  [selectedItemsLabel]="selectedItemsLabel || customSelectedLabel(value, options, optionLabel)"
  [maxSelectedLabels]="maxSelectedLabels"
  (onChange)="onDropdownChange($event.value)"
  [optionDisabled]="disableWrapper"
  [filter]="filterable"
  [showToggleAll]="!searchText || filteredOptions.length > 0"
  (onPanelHide)="onPanelHide()"
>
<ng-template pTemplate="selectedItems" let-values let-removeChip="removeChip">
  <ng-container *ngIf="display === 'chip'">
    <ng-container *ngFor="let item of values | slice:0:maxSelectedLabels">
      <div class="p-multiselect-token">
        <span class="p-multiselect-token-label">{{ getOptionLabel($any(item)) }}</span>
        <span *ngIf="!disabled" class="p-multiselect-token-icon"
              (click)="removeChip($any(item)[optionValue], $event); $event.stopPropagation()"
              (mousedown)="$event.stopPropagation()">
          <i class="pi pi-times-circle"></i>
        </span>
      </div>
    </ng-container>
    <div *ngIf="values?.length > maxSelectedLabels" class="p-multiselect-token">
      <span class="p-multiselect-token-label">+{{ values.length - maxSelectedLabels }} more</span>
    </div>
    <span *ngIf="!values?.length" class="p-multiselect-label p-placeholder">{{ placeholder }}</span>
  </ng-container>
  <ng-container *ngIf="display !== 'chip'">
    <span *ngIf="values?.length" class="p-multiselect-label">{{ customSelectedLabel(value, options, optionLabel) }}</span>
    <span *ngIf="!values?.length" class="p-multiselect-label p-placeholder">{{ placeholder }}</span>
  </ng-container>
</ng-template>
<ng-template pTemplate="header">
  <div *ngIf="searchInput" class="qep-search-wrap">
    <label for="qep-search-input" class="sr-only">{{ placeholder ? 'Search ' + placeholder : 'Search' }}</label>
    <input
      id="qep-search-input"
      class="qep-search-input"
      type="text"
      [value]="searchText"
      (input)="searchText = $any($event.target).value"
      (click)="$event.stopPropagation()"
      (mousedown)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
      [placeholder]="placeholder ? 'Search ' + placeholder.toLowerCase() : 'Search...'"
    />
  </div>
  <div *ngIf="searchText && filteredOptions.length === 0" class="qep-no-results">No results found</div>
  <div *ngIf="!searchText || filteredOptions.length > 0" class="checkbox-all-text">{{ selectAllLabel }}</div>
</ng-template>
</p-multiSelect>

